import React from 'react';

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import BG from "../../Assets/Images/splash.jpg";
import {VscHome} from "react-icons/vsc";
import {TbArrowBadgeLeft} from "react-icons/tb";
import {useParams} from "react-router-dom";

const currencyFormat = Intl.NumberFormat('en-US');

function Subscription() {
    const {car} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [plans, setPlans] = React.useState([]);
    const [selectedPlan, setSelectedPlan] = React.useState(0);


    React.useEffect(() => {
        API.getSubscription()
            .then((response) => {
                setIsLoaded(true);
                setPlans(response.data[0]);

            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }, []);

    const onPayClick = () => {
        setIsLoaded(false);
        const params = {
            entity_id : car,
            id : selectedPlan,
            return_url: `https://gps.telcarnet.com/home`,
            bank_unique_code : 'saderat'
        }
        API.getBankURL(params)
            .then((response) => {
                toast.success('تا لحظاتی دیگر به درگاه بانک متصل می شوید...')
                setTimeout (() => {
                    setIsLoaded(true);
                    window.location.assign(`${response.data.paymentURL}&external==true`);
                },1500)

            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
               <section className="container-fluid  overflow-hidden  pb-5 rtl px-0   "
                     style={{backgroundImage: `url('${BG}')`}}>
                <div className="row ">
                    <div className="col-12 ">
                        <nav className="navbar navbar-light bg-white mb-4 p-0 m-0 actionbar  py-2">
                             <span className='mx-3 sign-out' onClick={
                                 () => {
                                     window.location.assign(`/home`)
                                 }
                             }>
                                <VscHome className='mx-1 text-big-2'/>
                                صفحه اصلی
                            </span>
                            <a className="navbar-brand mx-4" href="#">
                               {/* <img src={LogoPic} alt="TelCarNet" className="rounded " width="30"/>*/}
                            </a>

                        </nav>
                    </div>
                </div>

                <div className="row mx-2 mb-3">
                    <div className="col-md-12 min-vh-100 ">
                        <div className="row ">
                            {
                                plans.map(plan => {
                                    return (
                                        <div className="col-md-4 px-2 mt-3">
                                        <div className={plan.id === selectedPlan ? "card bg-custom" : "card"}>
                                            <div className="card-body">
                                                <div className="fw-bold">
                                                    {
                                                        plan.title
                                                    }
                                                    &nbsp;
                                                    <span className=
                                                        {plan.id === selectedPlan ? 'badge badge-info badge-pill bg-success float-start text-big-1 ' : 'badge badge-info badge-pill bg-success float-start '}
                                                    >
                                                          {

                                                              currencyFormat.format(plan.price)
                                                          }
                                                          &nbsp;
                                                        ریال
                                                    </span>
                                                </div>
                                                <p className='mt-3 text-small-1 text-justify' dangerouslySetInnerHTML={{ __html:  plan.description }}></p>
                                                <div className='text-start'>
                                                    <span className='badge badge-info badge-pill bg-info float-end mt-1 text-big-1'>
                                                        {
                                                            plan.duration
                                                        }
                                                        &nbsp;
                                                        روزه
                                                    </span>
                                                    <button className=
                                                            {plan.id === selectedPlan ? "btn btn-warning px-5" : "btn btn-secondary px-5"}
                                                    onClick={() => {
                                                        setSelectedPlan(plan.id)
                                                    }}
                                                    >
                                                        انتخاب
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        </div>
                                    )
                                })
                            }
                        </div>
                        {
                            selectedPlan > 0 ?
                                <div className="row">
                                    <div className="col-12 p-2 fixed-bottom max-w-lg">
                                        <button
                                            className="btn btn-success bg-secondary-color text-end text-small-1 text-semi-big  w-100 p-2  pe-4 border-0"
                                            onClick={onPayClick}
                                        >
                                           خرید و شارژ پنل
                                            <span className="badge  p-2 float-start">

                                                <TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                                        </button>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default Subscription;